// 完工报表列表
import request from '@/utils/request'

// 完工报表列表
export function apiCompletionReportList (data) {
  return request({
    url: '/mes/mesDiscreteJobs/completionReportList',
    method: 'post',
    data: data
  })
}

// 完工报表列表导出
export function apiCompletionReportListExport (data) {
  return request({
    url: '/mes/mesDiscreteJobs/completionReportListExport',
    method: 'post',
    data: data
  })
}
